import { ReactNode } from 'react';
import cn from 'classnames';
import { SpecialistCssTypes } from '@features/components/CaseCard/Blocks/Base/types';

type MiniCardProps = {
  cssStyles: SpecialistCssTypes;
  classNames: string;
  leftItem: ReactNode;
  rightItem: ReactNode;
  label?: ReactNode;
  value?: string;
  icon?: ReactNode;
};

export const MiniCard = ({ cssStyles, classNames, leftItem, rightItem, label, value, icon }: MiniCardProps) => {
  return (
    <div className={cn('py-2 px-3 flex items-center rounded-xl', classNames)}>
      {leftItem}
      <div className="flex-1 min-w-20">
        <div className="flex gap-1 items-center">
          <div className={cn('truncate', cssStyles.role)}>{label}</div>
          {icon}
        </div>
        <div className={cn('text-s-r truncate', cssStyles.fullName)}>{value}</div>
      </div>
      {rightItem}
    </div>
  );
};
